// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"15d11c7f","693":"86f6ac59"}[chunkId] + ".chunk.js";
};